module.exports = __webpack_public_path__ + "img/arrow-left.720d8e87.svg";